




























































import Vue from "vue";
import RAMenu from "@/components/RAMenu.vue";
  
export default Vue.extend({
  name: "RAGameplayElements",
  components: {
    RAMenu
  }
});
